import Config from '../../config/AppConfig'
import {
  mergeMap,
  switchMap,
  concatMap,
  map,
  catchError,
  withLatestFrom,
  repeat, tap, ignoreElements, debounceTime,
} from 'rxjs/operators'
import {of, from, merge, concat} from 'rxjs'
import * as actions from './actions'
//import {actions as toastrActions} from 'react-redux-toastr'
import {ofType} from 'redux-observable'
import {Auth, Analytics} from 'aws-amplify'
import Cookies from 'js-cookie'
import {ajax} from 'rxjs/ajax'
import uuid from 'uuid/v4'
import {history} from '../../config/Redux'
import I18n from 'i18n-js'
import queryString from 'query-string'
import jwtDecode from 'jwt-decode';
import {getUrlForPublicSite, setCookie, trackGoogleTagManager} from '../../lib/Utils'

// TODO: Figure out a better way to store these so user can confirm and be logged in
let createUserEmail
let createUserPassword

export const signIn = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SIGN_IN),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      const {password, redirectUrl, createRetailerAfter, createRetailerData} = action.payload;
      const email = action.payload.email || state.auth.resetPasswordRequired;
      let {redirect = true} = action.payload;

      // If the user is invited to a retailer,
      // redirect before showing createRetailer form
      if (state.auth.queryParams && state.auth.queryParams.invite_link) {
        redirect = true
      }

      return from(Auth.signIn(email.toLowerCase(), password)).pipe(
        map(user => ({action, user, redirect, email, redirectUrl, createRetailerAfter, createRetailerData})))
    }),
    switchMap(({user, redirect, redirectUrl, createRetailerAfter, createRetailerData}) => {
      if (user.challengeName) {
        return of({
          type: actions.SIGN_IN_REJECTED,
          payload: user,
        })
      }
      //Set up JWT
      const jwt = user.signInUserSession.idToken && user.signInUserSession.idToken.jwtToken;

      //Set up access token
      const accessToken = user.signInUserSession.accessToken && user.signInUserSession.accessToken.jwtToken;

      //Decode JWT and extract payload if it exists.
      const decodedJwt = jwt ? jwtDecode(jwt) : [];

      //Checking if user is from new app or from monolith. Checking for APP2 group.
      const groups = decodedJwt.hasOwnProperty('cognito:groups') ? decodedJwt['cognito:groups'] : [];
      const isNewApp = groups.includes('APP2');

      //Set token to access api
      const token = isNewApp ? accessToken : jwt;

      return merge(
        of({
          type: actions.SIGN_IN_FULFILLED,
          payload: {...user, createRetailerAfter, createRetailerData},
        }),
        /* of({
           type: actions.UPDATE_PINPOINT_ENDPOINT,
           payload: {
             username: user.username,
             userId: user.attributes && user.attributes['custom:internal_id'],
           },
         }),*/
        of({
          type: actions.CUSTOM_EMAIL_VERIFICATION,
          payload: {token, isNewApp},
        }),
        (redirect || !isNewApp) ?
          of({
            type: actions.SET_LEGACY_SESSION,
            payload: {...user.signInUserSession, redirectUrl, redirect},
          }) :
          of({
            type: 'NO_OP',
            payload: {},
          }),
      )
    }),
    catchError(payload => {
      if (payload.code === 'PasswordResetRequiredException') {
        return merge(
          of({
            type: actions.RESET_PASSWORD_REQUIRED
          }),
          of({
            type: actions.SIGN_IN_REJECTED,
            payload
          })
        )
      }
      return merge(
        of({
          type: actions.SIGN_IN_REJECTED,
          payload,
        }))
    }),
    repeat()
  )
}

export const signInFacebook = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SIGN_IN_FACEBOOK),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const token = action.payload.accessToken
      const expiresAt = action.expiresIn * 1000 + new Date().getTime()
      const user = {
        email: action.payload.email,
        name: action.payload.name,
        given_name: action.payload.first_name,
        family_name: action.payload.last_name,
        phone_number: '+380937049139',
      }
      return from(Auth.federatedSignIn('facebook', {token, expiresAt}, user)).pipe(
        mergeMap(payload => {
          console.info(payload)
          return merge(
            of({
              type: actions.SIGN_IN_FACEBOOK_FULFILLED,
              payload,
            })
          )
        }),
        catchError(payload => {
          console.info(payload)
          return of({
            type: actions.SIGN_IN_FACEBOOK_REJECTED,
            payload,
          })
        })
      )
    })
  )
}

export const signInGoogle = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SIGN_IN_GOOGLE),
    withLatestFrom(state$),
    concatMap(() => {
      return from(Auth.federatedSignIn({provider: 'Google'})).pipe(
        mergeMap(payload => {
          console.info(payload)
          return merge(
            of({
              type: actions.SIGN_IN_GOOGLE_FULFILLED,
              payload,
            })
          )
        }),
        catchError(payload => {
          console.info(payload)
          return of({
            type: actions.SIGN_IN_GOOGLE_REJECTED,
            payload,
          })
        })
      )
    })
  )
}

export const setLegacySession = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SET_LEGACY_SESSION),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const jwt = action.payload.idToken.jwtToken
      const refreshToken = action.payload.refreshToken.token;
      const redirect = action.payload.redirect;
      const {createRetailerAfter, createRetailerData} = action.payload;
      // state.auth.redirect_url comes from main user_auth app query params
      // action.payload.redirectUrl can come from either the invite flow
      // or the hubspotWidget
      const redirectUrlFromQueryParams = state.auth.queryParams && state.auth.queryParams.redirect_url;
      const redirectUrlFromPayload = action.payload.redirectUrl || '/account/dashboard';
      const redirectUrl = redirectUrlFromQueryParams || redirectUrlFromPayload;

      const accessToken = action.payload.accessToken.jwtToken
      const userEmail = state.auth.user.username
      const settings = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${jwt}`,
        },
        url: `${Config.LAMBDA_API_BASE}/session`,
      }
      return ajax(settings).pipe(
        mergeMap(payload => {
            setCookie('userSessionIdentifier', jwt, 1);
            setCookie('currentUserEmail', userEmail);
            setCookie('refreshToken', refreshToken);
            setCookie('accessToken', accessToken);
          const userHasInvite = !!(
            state.auth.queryParams && state.auth.queryParams.invite_link
          )

          if (userHasInvite) {
            return of({
              type: 'ACCEPT_INVITE',
              payload: {},
            })
          } else {
            return of({
              type: actions.SET_LEGACY_SESSION_FULFILLED,
              payload: {...payload.response, redirectUrl, redirect, createRetailerData, createRetailerAfter},
            })
          }
        }),
        catchError(payload => {
          return of({
            type: actions.SET_LEGACY_SESSION_REJECTED,
            payload,
          })
        })
      )
    })
  )
}

export const customEmailVerification = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CUSTOM_EMAIL_VERIFICATION),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      const {isNewApp, token} = action.payload;
      const apiVersion = isNewApp ? '/v2' : '';
      const settings = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        url: `${Config.LAMBDA_API_BASE}${apiVersion}/email_verification`,
      }
      return ajax(settings).pipe(
        map(payload => {
          return {
            type: actions.CUSTOM_EMAIL_VERIFICATION_FULFILLED,
            payload: payload.response,
          }
        }),
        catchError(payload => {
          return of({
            type: actions.CUSTOM_EMAIL_VERIFICATION_REJECTED,
            payload,
          })
        })
      )
    })
  )
}

export const updatePinpointEndpoint = (action$, state$) => {
  return action$.pipe(
    ofType(actions.UPDATE_PINPOINT_ENDPOINT),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      const {username, userId, gettingStartedSource} = action.payload
      // For data-formatting: https://aws-amplify.github.io/docs/js/analytics#update-endpoint
      const userAttributes = {}
      if (gettingStartedSource) {
        userAttributes.gettingStartedType = [gettingStartedSource]
      }
      const data = {
        address: username,
        channelType: 'APNS',
        userId,
        userAttributes
      }
      return from(Analytics.updateEndpoint(data)).pipe(
        map(payload => {
          return {
            type: actions.UPDATE_PINPOINT_ENDPOINT_FULFILLED,
            payload
          }
        }))
    }),
    catchError(payload => {
      return of({
        type: actions.UPDATE_PINPOINT_ENDPOINT_REJECTED,
        payload,
      })
    })
  )
}

export const completeNewPassword = (action$, state$) => {
  return action$.pipe(
    ofType(actions.COMPLETE_NEW_PASSWORD),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      const {password, ...rest} = action.payload
      const user = state.auth.user
      return from(Auth.completeNewPassword(user, password, rest)).pipe(
        mergeMap(payload => {
          return merge(
            of({
              type: actions.SIGN_IN_FULFILLED,
              payload,
            }),
            of({
              type: actions.SET_LEGACY_SESSION,
              payload: user.signInUserSession.idToken.jwtToken,
            })
          )
        }),
        catchError(payload => {
          return of({
            type: actions.COMPLETE_NEW_PASSWORD_REJECTED,
            payload,
          })
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.COMPLETE_NEW_PASSWORD_REJECTED,
        payload,
      })
    })
  )
}

export const resetPassword = (action$, state$) => {
  return action$.pipe(
    ofType(actions.RESET_PASSWORD),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const {phoneNumber} = action.payload
      return from(Auth.forgotPassword(phoneNumber)).pipe(
        mergeMap(payload => {
          return of({
            type: actions.RESET_PASSWORD_FULFILLED,
            payload: {...payload, phoneNumber},
          })
        }),
        catchError(payload => {
          return of({
            type: actions.RESET_PASSWORD_REJECTED,
            payload,
          })
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.RESET_PASSWORD_REJECTED,
        payload,
      })
    })
  )
}

export const resetPasswordByEmail = (action$, state$) => {
  return action$.pipe(
    ofType(actions.RESET_PASSWORD_BY_EMAIL),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const {email} = action.payload
      return from(Auth.forgotPassword(email)).pipe(
        mergeMap(payload => {
          return of({
            type: actions.RESET_PASSWORD_BY_EMAIL_FULFILLED,
            payload: {...payload, email},
          })
        }),
        catchError(payload => {
          return of({
            type: actions.RESET_PASSWORD_BY_EMAIL_REJECTED,
            payload,
          })
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.RESET_PASSWORD_REJECTED,
        payload,
      })
    })
  )
}

export const confirmForgotPassword = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CONFIRM_FORGOT_PASSWORD),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      const resetPasswordRequired = state.auth.resetPasswordRequired;
      const username = state.auth.forgotPasswordUsername;
      const {verificationCode, password} = action.payload;
      return from(Auth.forgotPasswordSubmit(username, verificationCode, password)).pipe(
        mergeMap(payload => {
          if (resetPasswordRequired) {
            return merge(
              of({
                type: actions.SET_SPINNER_ON,
              }),
              of({
                type: actions.CONFIRM_FORGOT_PASSWORD_FULFILLED,
                payload,
              }),
              of({
                type: actions.SIGN_IN,
                payload: {
                  password
                }
              }))
          }
          return of({
            type: actions.CONFIRM_FORGOT_PASSWORD_FULFILLED,
            payload,
          })
        }),
        catchError(payload => {
          return of({
            type: actions.CONFIRM_FORGOT_PASSWORD_REJECTED,
            payload,
          })
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.CONFIRM_FORGOT_PASSWORD_REJECTED,
        payload,
      })
    })
  )
}

export const createAccount = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CREATE_ACCOUNT),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      const username = uuid()
      const {skipRetailer, redirectUrl, createRetailerAfter, createRetailerData, account} = action.payload;
      const payloadData = createRetailerAfter ? action.payload : action.payload[0];
      const isSkipRetailer = Boolean(skipRetailer);
      const {password, email, phoneNumber, firstName, lastName} = payloadData;
      createUserEmail = email.toLowerCase();
      createUserPassword = password;
      const signUpParams = {
        username,
        password,
        attributes: {
          email: createUserEmail,
          phone_number: phoneNumber.replace(/[\-()\s]*/g, ''),
          given_name: firstName,
          family_name: lastName,
          'custom:account_type': account || 'regular'
        },
      };

      return from(
        Auth.signUp(signUpParams)
      ).pipe(
        mergeMap(payload => {
          return merge(
            of({
              type: actions.ANALYTICS_TRACKING,
              payload: {eventType: 'UserSignup'}
            }),
            of({
              type: actions.CREATE_ACCOUNT_FULFILLED,
              payload: {
                ...payload,
                user_id: username,
                user_email: email,
                user_phone: phoneNumber,
                user_first_name: firstName,
                user_last_name: lastName,
                skipRetailer
              },
            }),
            of({
              type: actions.SIGN_IN,
              payload: {
                email: createUserEmail,
                password: createUserPassword,
                redirect: isSkipRetailer,
                redirectUrl: skipRetailer || redirectUrl,
                createRetailerAfter,
                createRetailerData
              },
            }),
            of({
              type: actions.CREATE_USER_HUBSPOT_ANALYTICS_TRACKING,
              payload: {
                email: createUserEmail,
                phone: phoneNumber,
                bar_name: createRetailerData ? createRetailerData.beverage_retailer_name : '',
                first_name: firstName,
                last_name: lastName,
              },
            }))
        }),
        catchError(payload => {
            // current aws-amplify lib returns wrong error message for InvalidParameterException. requires at least v3.0.8
            // https://github.com/aws-amplify/amplify-js/issues/5313
          return of({
            type: actions.CREATE_ACCOUNT_REJECTED,
            payload
          })
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.CREATE_ACCOUNT_REJECTED,
        payload,
      })
    }),
    repeat()
  )
}

export const confirmPhoneCode = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CONFIRM_PHONE_CODE),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      const code = action.payload.verificationCode.verificationCode;
      const skipRetailer = action.payload.skipRetailer;
      const redirectUrl = action.payload.redirectUrl
      const username = state.auth.createUserConfirm;
      return from(Auth.confirmSignUp(username, code)).pipe(
        mergeMap(() => {
          return concat(
            of({
              type: actions.SIGN_IN,
              payload: {
                email: createUserEmail,
                password: createUserPassword,
                redirect: skipRetailer,
                redirectUrl,
              },
            }),
            of({
              type: actions.CONFIRM_PHONE_CODE_FULFILLED,
              payload: skipRetailer
            })
          )
        }),
        catchError(payload => {
          return of({
            type: actions.CONFIRM_PHONE_CODE_REJECTED,
            payload,
          })
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.CONFIRM_FORGOT_PASSWORD_REJECTED,
        payload,
      })
    })
  )
}

export const createRetailer = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CREATE_RETAILER),
    debounceTime(1000),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const jwtToken = (state.auth &&
        state.auth.user &&
        state.auth.user.signInUserSession &&
        state.auth.user.signInUserSession.idToken &&
        state.auth.user.signInUserSession.idToken.jwtToken)
        ? state.auth.user.signInUserSession.idToken.jwtToken : '';
      const {
        beverage_retailer_name,
        address_line_1,
        address_line_2,
        city,
        stateAddress,
        postal_code,
        retailer_timezone,
        countryCode,
        gettingStartedSource,
        retailerAccountType,
        redirectUrl,
        createRetailerAfter,
        regionAddress,
        userData
      } = action.payload;

      const stateSet = (country, stateAddress, regionAddress) => {
        if (country === 'US' && stateAddress === '') {
          return 'AL'
        }
        if (country === 'US') {
          return stateAddress;
        }
        return regionAddress;
      }

      const country = countryCode || 'US';
      const stateCode = stateSet(country, stateAddress, regionAddress);

      const {
        user_id,
        user_email,
        user_phone,
        user_first_name,
        user_last_name,
        token
      } = userData || state.auth;

      const jwt = token ? token : jwtToken;

      // Format formData for legacy API request because it doesn't support JSON
      const formData = new FormData()
      formData.append('user_id', user_id)
      formData.append('user_email', user_email)
      formData.append('user_phone', user_phone)
      formData.append('user_first_name', user_first_name)
      formData.append('user_last_name', user_last_name)
      formData.append('retailer_address_line1', address_line_1)
      formData.append('retailer_address_line2', address_line_2)
      formData.append('retailer_city', city)
      formData.append('retailer_state', stateCode)
      formData.append('retailer_country', country)
      formData.append('retailer_zipcode', postal_code)
      formData.append('retailer_timezone', retailer_timezone)
      //TODO Find other way to get this! MOC
      formData.append('is_paying_by_card', true)
      formData.append('free_trial_source', gettingStartedSource)
      formData.append('retailer_getting_started_type', retailerAccountType)
      //Set correct account type
      switch (retailerAccountType) {
        case 'inventory_template_food':
        case 'recipe_costing_food':
        case 'owner_food':
        case 'kitchen_manager':
        case 'invoice_upload_food':
          formData.append('food_retailer_name', beverage_retailer_name)
          break;
        default:
          formData.append('beverage_retailer_name', beverage_retailer_name)
      }

      const settings = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
        body: formData,
        url: getUrlForPublicSite('/user/create_retailer/'),
      };

      return ajax(settings).pipe(
        mergeMap(payload => {
          return merge(
            of({
              type: actions.CREATE_RETAILER_FULFILLED,
              payload: payload.response,
            }),
            of({
              type: actions.SAVE_RETAILER,
              payload: {
                userId: user_id,
                createRetailerResponse: payload.response,
                retailerName: beverage_retailer_name,
                addressLine1: address_line_1,
                addressLine2: address_line_2,
                city,
                zipCode: postal_code,
                countryCode,
                gettingStartedSource,
                redirectUrl,
                createRetailerAfter,
                jwt
              },
            }),
            /*of({
              type: actions.UPDATE_PINPOINT_ENDPOINT,
              payload: {
                username: user_email,
                userId: user_id,
                gettingStartedSource
              }
            })*/
            of({
              type: actions.CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING,
              payload: {
                user_first_name: user_first_name,
                user_last_name: user_last_name,
                user_email: user_email,
                user_phone: user_phone,
                beverage_retailer_id: payload.response.beverage_retailer_id,
                food_retailer_id: payload.response.food_retailer_id,
                retailer_name: beverage_retailer_name,
                retailer_address_line1: address_line_1,
                retailer_address_line2: address_line_2,
                retailer_country_code: country,
                retailer_city: city,
                retailer_zipcode: postal_code,
                getting_started_source: gettingStartedSource,
                creator_user_id: user_id,
              },
            })
          )
        }),
        catchError(payload => {
          return of({
            type: actions.CREATE_RETAILER_REJECTED,
            payload,
          })
        })
      )
    })
  )
};

export const saveRetailer = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SAVE_RETAILER),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const jwtToken = (state.auth &&
        state.auth.user &&
        state.auth.user.signInUserSession &&
        state.auth.user.signInUserSession.idToken &&
        state.auth.user.signInUserSession.idToken.jwtToken)
        ? state.auth.user.signInUserSession.idToken.jwtToken : '';
      const jwt = action.payload.jwt ? action.payload.jwt : jwtToken;
      const {
        createRetailerResponse, addressLine1, addressLine2,
        city, zipCode, countryCode, gettingStartedSource, userId, retailerName, redirectUrl, createRetailerAfter
      } = action.payload;
      const accountType = createRetailerResponse.food_retailer_id ? 'food' : 'beverage';
      const retailerId = createRetailerResponse.food_retailer_id || createRetailerResponse.beverage_retailer_id;
      const retailerIdAnalytics = retailerId || 'UNKNOWN';
      const saveRetailerData = JSON.stringify({
        accountType,
        addressLine1,
        addressLine2,
        city,
        zipCode,
        countryCode,
        gettingStartedSource,
        retailerId,
        userId,
        retailerName,
      });

      const settings = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${jwt}`,
        },
        body: saveRetailerData,
        url: `${Config.LAMBDA_API_BASE}/retailer`,
      };
      return ajax(settings).pipe(
        mergeMap(payload => {
          if (createUserEmail) {
            return merge(
              of({
                type: actions.SAVE_RETAILER_FULFILLED,
                payload: {...payload.response, retailerId, redirectUrl, createRetailerAfter},
              }),
              of({
                type: actions.ANALYTICS_TRACKING,
                payload: {eventType: 'CreateRetailer', eventPayload: retailerIdAnalytics}
              }),
              createUserEmail &&
              of({
                type: actions.SIGN_IN,
                payload: {
                  email: createUserEmail,
                  password: createUserPassword,
                  redirectUrl
                },
              })
            )
          } else {
            window.location.href = getUrlForPublicSite('/');
            return of({
              type: 'NO_OP',
              payload: {},
            })
          }
        }),
        catchError(payload => {
          return of({
            type: actions.SAVE_RETAILER_REJECTED,
            payload,
          })
        })
      )
    })
  )
}

export const loginError = action$ => {
  return action$.pipe(
    ofType(
      actions.SIGN_IN_REJECTED,
      actions.CONFIRM_SIGN_IN_REJECTED,
      actions.CONFIRM_PHONE_CODE_REJECTED,
      actions.COMPLETE_NEW_PASSWORD_REJECTED,
      actions.SETUP_ONE_TIME_PASSWORD_REJECTED,
      actions.SET_LEGACY_SESSION_REJECTED,
      actions.RESET_PASSWORD_REJECTED,
      actions.RESET_PASSWORD_BY_EMAIL_REJECTED,
      actions.CONFIRM_FORGOT_PASSWORD_REJECTED,
      actions.CREATE_ACCOUNT_REJECTED
    ),
    map(action => {
      // Currently catches all messages or returns generic error message
      let errorMessage = action.payload.message || I18n.t('errors.generic');
      let errorCode = action.payload.code;
      let emailError = false;
      let phoneError = false;

      // The errors from the lambdas all have the same key
      // Message is prettified based on message string :-/
      if (errorCode === 'UserLambdaValidationException') {
        switch (errorMessage) {
          // eslint-disable-next-line max-len
          case 'PreSignUp failed with error Sorry, it looks like this phone number is in use. If you think this is an error, please reach out to support@bevspot.com..':
            errorMessage = I18n.t('errors.phoneNumberInUseException');
            phoneError = true;
            break;
          // eslint-disable-next-line max-len
          case 'PreSignUp failed with error Sorry, it looks like a user account with this email address already exists. Try logging in or use a different email..':
            errorMessage = I18n.t('errors.emailInUseException');
            emailError = true;
            break;
          default:
            break;
        }
      } else {
        // Other errors from AWS will have different error codes
        switch (errorCode) {
          case 'UserNotFoundException':
            errorMessage = I18n.t('errors.userNotFoundException')
            emailError = true;
            break;
          case 'NotAuthorizedException':
            errorMessage = I18n.t('errors.notAuthorizedException')
            emailError = true;
            break;
          default:
            // Worst case scenario, we pass the error message through as it is
            break;
        }
      }
      // return toastrActions.add({
      //   type: 'error',
      //   title: errorMessage,
      // })
      return {
        type: actions.LOGIN_ERROR,
        payload: {errorMessage, emailError, phoneError}
      }
    })
  )
}

export const setUrlParams = action$ => {
  return action$.pipe(
    ofType(actions.SET_URL_PARAMS),
    concatMap(() => {
      const urlParams = queryString.parse(window.location.search)
      return of({
        type: actions.SET_URL_PARAMS_FULFILLED,
        payload: urlParams,
      })
    }),
    catchError(payload => {
      return of({
        type: actions.SET_URL_PARAMS_REJECTED,
        payload,
      })
    })
  )
}

export const acceptInvite = (action$, state$) => {
  return action$.pipe(
    ofType(actions.ACCEPT_INVITE),
    withLatestFrom(state$),
    mergeMap(([, state]) => {
      const jwt = Cookies.get('userSessionIdentifier')
      const inviteLink = state.auth.queryParams.invite_link
      const userId = state.auth.user.username ? state.auth.user.username : state.auth.user['cognito:username']

      const formData = new FormData()
      formData.append('userId', userId)
      formData.append('invite_link', inviteLink)

        const settings = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${jwt}`,

        },
        body: formData,
        url: getUrlForPublicSite('/join_establishment/'),
      };

      return ajax(settings).pipe(
        map(payload => {
          const {success, redirect_to} = payload.response
          if (success) {
              window.location.href = getUrlForPublicSite(redirect_to)
          }
          return {
            type: actions.ACCEPT_INVITE_FULFILLED,
            payload,
          }
        })
      )
    }),
    catchError(payload => {
      return of({
        type: actions.ACCEPT_INVITE_REJECTED,
        payload,
      })
    })
  )
}

// Redirect epics
export const forgotPasswordRedirect = action$ => action$.pipe(
  ofType(actions.SIGN_IN_REJECTED),
  tap((action) => {
    if (action.payload.code === 'PasswordResetRequiredException') {
      history.push('/auth/forgot-password')
    }
  }),
  ignoreElements(),
);

export const confirmForgotPasswordFulfilledRedirect = (action$, state$) => action$.pipe(
  ofType(actions.CONFIRM_FORGOT_PASSWORD_FULFILLED),
  withLatestFrom(state$),
  tap(([, state]) => {
    if (!state.auth.resetPasswordRequired) {
      history.push('/auth')
    }
  }),
  ignoreElements(),
);

export const setLegacySessionRedirect = (action$, state$) => action$.pipe(
  ofType(actions.SET_LEGACY_SESSION_FULFILLED),
  withLatestFrom(state$),
  tap(([action]) => {
    const {redirectUrl, redirect} = action.payload;
    if (redirect) {
        window.location.href = getUrlForPublicSite(redirectUrl)
    }
  }),
  ignoreElements(),
);

export const saveRetailerRedirect = (action$, state$) => action$.pipe(
  ofType(actions.SAVE_RETAILER_FULFILLED),
  withLatestFrom(state$),
  tap(([action, state]) => {
    const {isNewApp} = state;
    const {retailerId, createRetailerAfter, redirectUrl} = action.payload;
    if (createRetailerAfter && redirectUrl) {
        window.location.href = getUrlForPublicSite(redirectUrl);
    }
    if (!isNewApp && !redirectUrl) {
        window.location.href = getUrlForPublicSite(`/r/${retailerId}`)
    }
    if (isNewApp) {
      history.push('/auth')
    }
  }),
  ignoreElements(),
);

export const createRetailerAfterUserCreation = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SIGN_IN_FULFILLED),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const {createRetailerData, createRetailerAfter} = action.payload;
      if (createRetailerAfter) {
        return of({
          type: actions.CREATE_RETAILER,
          payload: {...createRetailerData, createRetailerAfter}
        })
      }
      return of({
          type: 'NO_OP'
        }
      )
    })
  );
};

//GTM
export const createAnalyticsTrackingAction = (action$, state$) => {
  return action$.pipe(
    ofType(actions.ANALYTICS_TRACKING),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const {eventType, eventPayload} = action.payload;
      return from(eventPayload ? trackGoogleTagManager(eventType, eventPayload) : trackGoogleTagManager(eventType))
        .pipe(mergeMap(() => {
          return of({
            type: actions.ANALYTICS_TRACKING_SUCCESS,
            payload: eventType
          })
        }))
    })
  );
};

export const createUserHubspotAnalyticsTrackingAction = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CREATE_USER_HUBSPOT_ANALYTICS_TRACKING),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const formData = new FormData();
      formData.append('email', action.payload.email);
      formData.append('phone', action.payload.phone);
      formData.append('bar_name', action.payload.bar_name);
      formData.append('first_name', action.payload.first_name);
      formData.append('last_name', action.payload.last_name);
      formData.append('subscribe_to_blog', 'true');
      formData.append('hubspot_cookie', Cookies.get('hubspotutk'));
      formData.append('is_admin_created', 'false');
      formData.append('source_url', window.location.href);
      formData.append('should_receive_marketing', 'true');

      const settings = {
        method: 'POST',
        body: formData,
        url: getUrlForPublicSite('/webhooks/hubspot/user_sign_up/'),
      };

      return ajax(settings).pipe(mergeMap(() => {
          return of({
            type: actions.CREATE_USER_HUBSPOT_ANALYTICS_TRACKING_SUCCESS,
            payload: {}
          })
        }))
    }),
    catchError(payload => {
      return of({
        type: actions.CREATE_USER_HUBSPOT_ANALYTICS_TRACKING_ERROR,
        payload
      })
    })
  );
};

export const creatRetailerHubspotAnalyticsTrackingAction = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING),
    withLatestFrom(state$),
    concatMap(([action]) => {
      const formData = new FormData();
      formData.append('user_first_name', action.payload.user_first_name);
      formData.append('user_last_name', action.payload.user_last_name);
      formData.append('user_email', action.payload.user_email);
      formData.append('user_phone', action.payload.user_phone);
      formData.append('beverage_retailer_id', action.payload.beverage_retailer_id);
      formData.append('food_retailer_id', action.payload.food_retailer_id);
      formData.append('retailer_name', action.payload.retailer_name);
      formData.append('retailer_address_line1', action.payload.retailer_address_line1);
      formData.append('retailer_address_line2', action.payload.retailer_address_line2);
      formData.append('retailer_country_code', action.payload.retailer_country_code);
      formData.append('retailer_city', action.payload.retailer_city);
      formData.append('retailer_zipcode', action.payload.retailer_zipcode);
      formData.append('creator_user_id', action.payload.creator_user_id);
      formData.append('source_url', document.referrer);
      formData.append('is_admin_created', 'false');
      formData.append('should_receive_marketing', 'true');
      formData.append('hubspot_cookie', Cookies.get('hubspotutk'));
      formData.append('getting_started_source', action.payload.getting_started_source);

      const settings = {
        method: 'POST',
        body: formData,
        url: getUrlForPublicSite('/webhooks/hubspot/retailer_created_by_user/'),
      };

      return ajax(settings).pipe(mergeMap(() => {
          return of({
            type: actions.CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING_SUCCESS,
            payload: {}
          })
        }))
    }),
    catchError(payload => {
      return of({
        type: actions.CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING_ERROR,
        payload
      })
    })
  );
};
